// extracted by mini-css-extract-plugin
module.exports = {"ProductsPins":"styles_ProductsPins__mdTed","ratio":"styles_ratio__c9a6S"};